ArticleEditor.add('plugin', 'print', {
    translations: {
        en: {
            "print": {
                "print": "Print"
            }
        }
    },
    defaults: {
        icon: '<svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m10.125 1c.9760221 0 1.7936348.73390752 1.8692894 1.6885462l.0057106.14478713v3.16666667h1.0714286c.9927325 0 1.8438171.72087115 1.9226216 1.68668386l.0059498.14664947v3.33333337c0 .989117-.8038115 1.757089-1.7808027 1.8279863l-.1477687.005347h-1.0714286v.25c0 .9538999-.7859079 1.674765-1.7254643 1.7444667l-.1495357.0055333h-5.25c-1.00418792 0-1.875-.7458949-1.875-1.75v-.25h-1.07142857c-.99273257 0-1.8438171-.7208712-1.92262167-1.6866839l-.00594976-.1466494v-3.33333337c0-.98911703.80381155-1.757089 1.78080273-1.82798629l.1477687-.00534704h1.07142857v-3.16666667c0-.97542885.77113545-1.75578536 1.7298577-1.82789317l.1451423-.00544016zm-.125 11h-5v1h5zm3-4h-11v3l1.17735638-.0000851c.30466973-.6036661.96572942-.9999149 1.69764362-.9999149h5.25c.7319142 0 1.3929739.3962488 1.6976436.9999149l1.1773564.0000851zm-3-5h-5v3h5z"/></svg>'
    },
    start: function() {
        this.app.editor.addButton('print', {
            title: '## print.print ##',
            icon: this.opts.print.icon,
            command: 'print.toggle',
            position: {
                'before': 'html'
            }
        });
    },
    toggle: function() {
        this.app.editor.getWinNode().print();
    }
});